import { render, staticRenderFns } from "./CreateEditTax.vue?vue&type=template&id=22c3325a"
import script from "./CreateEditTax.vue?vue&type=script&lang=js"
export * from "./CreateEditTax.vue?vue&type=script&lang=js"
import style0 from "./CreateEditTax.vue?vue&type=style&index=0&id=22c3325a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports